import { render } from "./FeaturedItems.vue?vue&type=template&id=d63faca6&scoped=true"
import script from "./FeaturedItems.vue?vue&type=script&lang=ts"
export * from "./FeaturedItems.vue?vue&type=script&lang=ts"

import "./FeaturedItems.vue?vue&type=style&index=0&id=d63faca6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d63faca6"

export default script